import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  /* 20250327
  { path: "/menu01", name: "Menu01", component: () => import("@/views/Menu01.vue")},
  { path: "/menu02", name: "Menu02", component: () => import("@/views/Menu02.vue")},
  { path: "/menu03", name: "Menu03", component: () => import("@/views/Menu03.vue")},
  { path: "/menu04", name: "Menu04", component: () => import("@/views/Menu04.vue")},
  { path: "/menu05", name: "Menu05", component: () => import("@/views/Menu05.vue")}
   */
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
